import React from 'react';
import { SectionCta } from './CtaButton';
export function ToolkitIntro() {
  return <section className="bg-cream px-5 py-16 sm:py-20" aria-labelledby="toolkit-title" data-id="element-249" data-mp="bwhdr8oqvlin">
      <div className="mx-auto max-w-3xl text-center" data-id="element-250" data-mp="6x4ko67a5i7m">
        <h2 id="toolkit-title" className="text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-251" data-mp="6xo0nhdddwj0">
          YOUR AAC PLANNING TOOLKIT — <span className="text-teal" data-id="element-252" data-mp="zljvshnajgdo">ORGANIZED IN ONE PLACE</span>
        </h2>
        <p className="mt-8 text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-253" data-mp="zjfu86cv6tgk">
          You don’t need another resource filled with disconnected theory.
        </p>
        <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-254" data-mp="qjsurq3p3xq5">
          You need a practical way to organize what you know, identify what needs attention, and plan the next steps in your AAC work.
        </p>
        <div className="mx-auto my-8 h-px w-20 bg-teal/40" data-id="element-255" data-mp="3bcnwrctgwbbx" />
        <p className="text-[17px] leading-relaxed text-muted" data-id="element-256" data-mp="36c030jdutge0">
          The AAC Clinical Blueprint™ brings together structured educational materials, planning worksheets, visual examples, and documentation tools in one organized collection.
        </p>
        <p className="mt-4 text-[17px] font-semibold leading-relaxed text-ink" data-id="element-257" data-mp="3tu3u3qs6xeyy">
          Everything is designed to help you approach AAC planning with greater clarity and structure.
        </p>
        <SectionCta label="Yes! I want the complete blueprint" data-id="element-258" data-mp="3kxw4nyxu9233" />
      </div>
    </section>;
}